import React from "react";
import { CommonPropertyProps } from "schemas/elements";
import Text from "../Text";

type Props = Omit<CommonPropertyProps, "value"> & {
	value: { [k: string]: string } | string;
	nextProp?: string;
};

export default ({
	updateStore,
	field,
	required,
	value,
	desc,
	validation,
	elementIndex,
	nextProp,
	id,
}: Props) => {
	const props = {
		updateStore,
		field,
		required,
		desc,
		elementIndex,
		value,
		validation,
		nextProp,
		id,
	};
	return <Text {...props} type={"regex"} />;
};
